import {
  getPageData as getPageDataWithPlatform,
  GetPageDataArgs,
} from "./getPageData";
import { createPlatform } from "./platform";
import { getResponsiveLayout } from "./responsiveLayout";
import { getNativeClient } from "./nativeClient";

export const getPageData =
  (
    data: Omit<GetPageDataArgs, "platform" | "responsiveLayout">,
  ): (() => Record<string, unknown>) =>
  (): Record<string, unknown> =>
    getPageDataWithPlatform({
      ...data,
      platform: createPlatform({
        nativeClient: getNativeClient(),
        responsiveLayout: getResponsiveLayout(window.innerWidth),
      }),
      responsiveLayout: getResponsiveLayout(window.innerWidth),
    })();
